import { MutationTree } from 'vuex'
import { MutationTypes } from './types'
import { State } from './state'

export type Mutations<S = State> = {
  [MutationTypes.TOGGLE_MARKERS_LOADING](state: S, payload: boolean): void;
  [MutationTypes.TOGGLE_DRAWER](state: S, payload: boolean): void;
  [MutationTypes.SET_IMEI](state: S, payload: any): void;
  [MutationTypes.SET_MARKER](state: S, payload: any): void;
  [MutationTypes.SET_SEARCH_FILTERED](state: S, payload: any): void;
  [MutationTypes.SET_SEARCH_BOUNDING](state: S, payload: boolean): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.TOGGLE_MARKERS_LOADING] (state, b) { state.markersLoaded = b },
  [MutationTypes.TOGGLE_DRAWER] (state, b) { state.drawer.active = b },
  [MutationTypes.SET_IMEI] (state, s) { state.selectedIMEI = s },
  [MutationTypes.SET_MARKER] (state, s) { state.selectedMarker = s },
  [MutationTypes.SET_SEARCH_FILTERED] (state, s) { state.search.filtered = s },
  [MutationTypes.SET_SEARCH_BOUNDING] (state, s) { state.search.bounding = s }
}
